import { pageTitle } from "../PageTitle";
import { useState } from "react";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/at.png";
import Architecture from "./../../assets/images/banner/Architecture.png";
// import Brochures from "./../../assets/images/WA_atd.png";
import { Link } from "react-router-dom";

const resultsData = [
  {
    metric: "Attendance marking time",
    before: "Manual register",
    after: "Instant",
  },
  {
    metric: "Records handled",
    before: "Limited manual capacity",
    after: "300% increase",
  },
  {
    metric: "Missed attendance entries",
    before: "Frequent",
    after: "Reduced significantly",
  },
  {
    metric: "Attendance accuracy",
    before: "Manual errors",
    after: "Improved accuracy",
  },
  { metric: "Processing time", before: "Slow", after: "80% faster" },
  { metric: "Hours saved monthly", before: "0", after: "60+ hours" },
];

const featureCards = [
  {
    icon: "bi bi-camera-fill",
    title: "Image-Based Attendance",
    desc: "Employees can mark attendance by sending a selfie or image through WhatsApp for fast and simple check-in.",
  },
  {
    icon: "bi bi-clock-fill",
    title: "Automatic Timestamp Capture",
    desc: "The system records attendance time automatically to reduce manual entry and improve tracking accuracy.",
  },
  {
    icon: "bi bi-folder2-open",
    title: "Structured Record Storage",
    desc: "Attendance images and details are stored in organized folders for easy verification and reporting.",
  },
  {
    icon: "bi bi-person-check-fill",
    title: "Employee Check-In Tracking",
    desc: "Tracks employee attendance instantly and helps businesses maintain centralized daily attendance records.",
  },
  {
    icon: "bi bi-check2-circle",
    title: "Verification & Monitoring",
    desc: "Supports attendance validation and helps reduce missing or incorrect attendance submissions.",
  },
  {
    icon: "bi bi-building",
    title: "Built for Workforce Operations",
    desc: "Suitable for construction sites, factories, warehouses, offices, and other staff attendance workflows.",
  },
];

const faqs = [
  {
    q: "How is this different from normal attendance systems?",
    a: "Traditional attendance systems often rely on manual registers, biometric devices, or app-based check-ins. Our WhatsApp AI makes attendance easier by allowing employees to send their attendance through WhatsApp, with automatic record capture and storage.",
  },
  {
    q: "Do employees need to install a separate app?",
    a: "No. Employees can use WhatsApp directly to submit attendance, making adoption easier and faster for the workforce.",
  },
  {
    q: "Can it capture attendance with images?",
    a: "Yes. Employees can send selfies or images through WhatsApp, and the system records the attendance along with the relevant details.",
  },
  {
    q: "Can it reduce manual HR effort?",
    a: "Yes. It automates attendance collection, reduces manual data entry, and makes workforce tracking more efficient.",
  },
  {
    q: "Where are the attendance records stored?",
    a: "Attendance records, including images and related details, can be stored in a structured centralized system for tracking, verification, and reporting.",
  },
  {
    q: "Who is this solution suitable for?",
    a: "It is ideal for businesses with field staff, site workers, shift-based teams, and organizations looking to simplify attendance tracking through WhatsApp.",
  },
];

const Wa_AT = () => {
  pageTitle("WhatsApp Attendance Tracking");

  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <>
      <HeaderOne />

      <div
        className="ai-overlay-wrapper-solutions"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        <div className="ai-overlay">
          <div className="ai-overlay-center-project-text-solutions">
            <h2 className="ai-overlay-project">
              AI-Powered WhatsApp <br /> Attendance Tracking
            </h2>
          </div>
          <div className="siw-hero-price-box-sol">
            <h3>From SGD 150/month</h3>

            <Link
              to="/contact"
              className="theme-btn theme-btn-one siw-hero-small-btn"
            >
              Start a Free Trial
            </Link>
          </div>
        </div>
      </div>

      <section className="py-3 py-md-4">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7 d-flex">
              <div className="food-grey-box w-100">
                <h3 className="siw-project-heading pb-1">
                  Built for real-time attendance tracking workflows
                </h3>
                <p className="mb-0 siw-rpa-desc">
                  Most attendance systems still depend on manual effort and
                  delayed updates. Employees may check in from different
                  locations, shifts, and work environments, which makes tracking
                  harder for managers and HR teams. Our WhatsApp AI allows staff
                  to mark attendance instantly through images and captures
                  attendance details automatically. It helps businesses maintain
                  faster, more accurate, and centralized attendance records.
                </p>
                <p className="siw-rpa-desc">
                  It works based on your actual workforce process and reporting
                  flow. The system can record attendance time, store images,
                  organize employee records, and support easier verification and
                  monitoring. It can simplify attendance collection for field
                  staff, site workers, shift teams, and office employees. This
                  reduces manual effort and improves attendance visibility
                  across your operations.
                </p>
              </div>
            </div>

            <div className="col-lg-5 d-flex">
              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/MrTOnAjBVsY?si=eeGCGI9xZkY4xx62"
                  title="WhatsApp Attendance Tracking Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-3 pt-md-0 pb-md-5 wafod-features-section">
        <div className="container">
          <h3 className="wafod-section-heading">Architecture</h3>
          <img
            src={Architecture}
            alt="Architecture"
            className="img-fluid mb-4"
            height="200"
          />
          <div className="mb-5">
            <h3 className="wafod-section-heading">Key Features</h3>
          </div>

          <div className="row g-4">
            {featureCards.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="food-feature-card wafod-feature-card h-100">
                  <div className="food-feature-icon wafod-feature-icon">
                    <i className={item.icon}></i>
                  </div>
                  <h5 className="wafod-card-title">{item.title}</h5>
                  <p className="mb-0 wafod-card-text">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-3 py-md-5 wafod-results-section">
        <div className="container">
          <div className="mb-4">
            <h3 className="wafod-section-heading-light pb-1">
              Business Impact
            </h3>
          </div>
          <div className="siw-subscription-table-wrap">
            <table className="siw-subscription-table">
              <thead>
                <tr>
                  <th>Metric</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>

              <tbody>
                {resultsData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.metric}</td>
                    <td>{row.before}</td>
                    <td>{row.after}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="pt-3 pb-2 py-md-4 wafod-faq-section">
        <div className="container">
          <div className="mb-5">
            <h3 className="wafod-section-heading">Common Questions</h3>
          </div>

          <div className="accordion wafod-accordion">
            {faqs.map((item, index) => (
              <div
                className="accordion-item food-accordion-item wafod-accordion-item mb-3"
                key={index}
              >
                <h2 className="accordion-header wafod-accordion-header">
                  <button
                    type="button"
                    className={`accordion-button food-accordion-btn wafod-accordion-btn ${
                      openIndex !== index ? "collapsed" : ""
                    }`}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                  >
                    {item.q}
                  </button>
                </h2>

                <div
                  className={`accordion-collapse collapse ${
                    openIndex === index ? "show" : ""
                  }`}
                >
                  <div className="accordion-body wafod-accordion-body">
                    {item.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FooterOne />
    </>
  );
};

export default Wa_AT;
